<div class="version-logs-container">
  <div class="header">
    <h2>Version Logs</h2>
    <div class="s3-status" [class.enabled]="s3Status?.isEnabled" [class.disabled]="!s3Status?.isEnabled">
      <span class="status-dot"></span>
      S3 {{ s3Status?.isEnabled ? 'Enabled' : 'Disabled' }}
    </div>
  </div>

  <!-- Stats -->
  <div class="stats-bar">
    <div class="stat">
      <span class="stat-value">{{ logs.length }}</span>
      <span class="stat-label">Versions</span>
    </div>
    <div class="stat uploaded">
      <span class="stat-value">{{ uploadedCount }}</span>
      <span class="stat-label">DB Uploaded</span>
    </div>
    <div class="stat pending">
      <span class="stat-value">{{ pendingCount }}</span>
      <span class="stat-label">DB Pending</span>
    </div>
    <div class="stat artifact-pending">
      <span class="stat-value">{{ artifactPendingCount }}</span>
      <span class="stat-label">Artifacts Pending</span>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters">
    <div class="filter-group">
      <label for="dbFilter">Database</label>
      <select id="dbFilter" [(ngModel)]="selectedDatabase" (change)="onFilterChange()">
        <option value="">All Databases</option>
        <option *ngFor="let db of trackedDatabases" [value]="db">{{ db }}</option>
      </select>
    </div>
    <div class="filter-group">
      <label for="roleFilter">Module / Role</label>
      <select id="roleFilter" [(ngModel)]="selectedRoleTypeId" (change)="onFilterChange()">
        <option [ngValue]="null">All Roles</option>
        <option *ngFor="let r of roleTypes" [ngValue]="r.roleTypeID">{{ r.roleTypeName }}</option>
      </select>
    </div>
    <div class="filter-group checkbox-group">
      <label class="checkbox-label">
        <input type="checkbox" [(ngModel)]="showPendingOnly" (change)="onFilterChange()">
        DB Pending Only
      </label>
    </div>
    <button class="btn-refresh" (click)="loadLogs()" [disabled]="loading">
      {{ loading ? 'Loading…' : 'Refresh' }}
    </button>
  </div>

  <div *ngIf="error" class="error-message">{{ error }}</div>
  <div *ngIf="loading" class="loading">Loading version logs…</div>

  <div *ngIf="!loading && filteredLogs.length === 0" class="empty-state">
    <p>No version logs found.</p>
  </div>

  <div *ngIf="!loading && filteredLogs.length > 0" class="table-container">
    <table class="version-logs-table">
      <thead>
        <tr>
          <th>Database</th>
          <th>Version</th>
          <th>Affected Roles</th>
          <th>DB S3 Path</th>
          <th>Role Artifacts</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let log of filteredLogs" [class.row-pending]="!log.isUploaded">

          <!-- Database -->
          <td class="cell-database">{{ isExternal ? (log.targetDatabase || log.databaseName) : log.databaseName }}</td>

          <!-- Version + date -->
          <td class="cell-version">
            <span class="version-name">{{ log.versionName }}</span>
            <span class="version-date">{{ formatDate(log.versionDate) }}</span>
            <span *ngIf="log.isUploaded" class="status-badge uploaded">Uploaded</span>
            <ng-container *ngIf="!log.isUploaded">
              <button
                *ngIf="s3Status?.isEnabled"
                class="btn-retry"
                (click)="retryExport(log)"
                [disabled]="isRetrying(log.exportLogID)">
                {{ isRetrying(log.exportLogID) ? 'Retrying…' : 'Retry Upload' }}
              </button>
              <span *ngIf="!s3Status?.isEnabled" class="status-badge pending">Pending</span>
              <div *ngIf="getRetryResult(log.exportLogID) as r"
                   class="retry-result" [class.success]="r.success" [class.error]="!r.success">
                {{ r.success ? 'Upload successful!' : r.errorMessage }}
              </div>
            </ng-container>
          </td>

          <!-- Affected roles badges -->
          <td class="cell-roles">
            <span *ngFor="let role of log.affectedRoles" class="role-badge">
              {{ role.roleTypeName }}
            </span>
            <span *ngIf="!log.affectedRoles?.length" class="none-text">—</span>
          </td>

          <!-- DB S3 path -->
          <td class="cell-s3">
            <span *ngIf="log.s3Path" class="s3-path" [title]="log.s3Path">
              {{ truncatePath(log.s3Path) }}
            </span>
            <span *ngIf="!log.s3Path && log.errorMessage" class="error-text" [title]="log.errorMessage">
              {{ log.errorMessage | slice:0:60 }}{{ log.errorMessage.length > 60 ? '…' : '' }}
            </span>
            <span *ngIf="!log.s3Path && !log.errorMessage" class="none-text">—</span>
          </td>

          <!-- Role artifacts mini-table -->
          <td class="cell-artifacts">
            <table *ngIf="log.roleArtifacts?.length" class="artifacts-table">
              <tbody>
                <tr *ngFor="let art of log.roleArtifacts">
                  <td class="art-role">{{ art.roleTypeName }}</td>
                  <td class="art-path">
                    <span *ngIf="art.s3Path" class="s3-path" [title]="art.s3Path">
                      {{ truncatePath(art.s3Path) }}
                    </span>
                    <span *ngIf="!art.s3Path" class="artifact-pending-badge">Pending CI/CD</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <span *ngIf="!log.roleArtifacts?.length" class="none-text">—</span>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
</div>
